import React from 'react';
import { Row, Button, Modal, ModalBody, ModalHeader } from 'reactstrap';
import { IRootState } from 'app/shared/reducers';
import { connect } from 'react-redux';
import { ENP, IND, ORG } from 'app/config/constants';

export interface IAuthSelectModalProps extends StateProps, DispatchProps {
  showModal: boolean;
  isAuthPassword: boolean;
  isAuthSMS: boolean;
  handleClose: Function;
  handleAddToken: Function;
  handleAddSim: Function;
  handleAddPhone: Function;
  handleAddPassword: Function;
  handleAddSmartCA: Function;
  handleAddApp: Function;
}
class AuthSelectModal extends React.Component<IAuthSelectModalProps> {
  addPassword = () => {
    if (this.props.isAuthSMS) {
      this.props.handleAddPassword();
    } else {
      this.props.handleAddPhone();
    }
  };

  render() {
    return (
      <div>
        <Modal
          className="hide-border-bottom-modal"
          isOpen={this.props.showModal}
          toggle={this.props.handleClose}
          backdrop="static"
          centered={window.location === window.parent.location}
        >
          <ModalHeader toggle={this.props.handleClose} />
          <ModalBody className="padding-modal-body">
            <Row className="justify-content-center bodyModal">
              <h4 className="font-weight-bold" style={{ marginBottom: '15px' }}>
                CHỌN PHƯƠNG THỨC XÁC THỰC
              </h4>
              <Button
                className="btn-register-white"
                type="button"
                block
                data-toggle="modal"
                data-target="#modalToken"
                onClick={() => this.props.handleAddToken()}
              >
                <span>XÁC THỰC BẰNG USB KÝ SỐ</span>
              </Button>
              {/* <Button className="btnSign" color="primary" type="button" block onClick={this.props.handleAddToken}>
                <span className="spanText">USB KÝ SỐ</span>
              </Button> */}
              {/*<Button className="btn-register-white" type="button" block onClick={() => this.props.handleAddSim()}>*/}
              {/*  <span>XÁC THỰC BẰNG SIM KÝ SỐ</span>*/}
              {/*</Button>*/}
              <Button className="btn-register-white" type="button" block onClick={() => this.props.handleAddPhone()}>
                <span>XÁC THỰC BẰNG TIN NHẮN SMS</span>
              </Button>

              {/*{this.props.userProfile.userType == IND ? (*/}
              {/*  <Button className="btn-register-white" type="button" block onClick={() => this.props.handleAddPhone()}>*/}
              {/*    <span>XÁC THỰC BẰNG TIN NHẮN SMS</span>*/}
              {/*  </Button>*/}
              {/*) : null}*/}

              {!this.props.isAuthPassword && this.props.userProfile.userType == IND ? (
                <Button className="btn-register-white" type="button" block onClick={() => this.addPassword()}>
                  <span>XÁC THỰC BẰNG MẬT KHẨU</span>
                </Button>
              ) : null}

              <Button className="btn-register-white" type="button" block onClick={() => this.props.handleAddApp()}>
                <span>XÁC THỰC BẰNG SMART OTP</span>
              </Button>

              {/*{this.props.userProfile.userType == ORG ? null : (*/}
              {/*  <Button className="btn-register-white" type="button" block onClick={() => this.props.handleAddSmartCA()}>*/}
              {/*    <span>XÁC THỰC BẰNG VNPT SMARTCA</span>*/}
              {/*  </Button>*/}
              {/*)}*/}
            </Row>
          </ModalBody>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (storeState: IRootState) => ({
  userProfile: storeState.userInfo.userProfile
});

const mapDispatchToProps = {};

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AuthSelectModal);
